/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import Select from "@components/anti/Forms/components/select"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import { groupedByYear } from "src/mixins"
import InvestorsPdfItem from "./investors-pdf-item"
import GovernancePdfItem from "./governance-pdf-item"

function InvestorsGovernanceWithFilter({
  locale,
  keyPhrase,
  data,
  loading,
  refetch,
  yearList,
  type,
}) {
  const Router = useRouter()
  const [trigger, anim] = useScrollAnim()
  const [state, setState] = useState({
    year: {
      label: translations[`all_year_${locale}`],
      value: 0,
    },
    orderBy: {
      label: translations[`newest_${locale}`],
      value: "newest",
    },
    list: data,
    yearOptions: [],
  })
  const handleChangeYear = async (year) => {
    if (+year === 0 || !year) {
      setState((prev) => ({
        ...prev,
        year: { label: translations[`all_year_${locale}`], value: 0 },
      }))
    } else {
      setState((prev) => ({ ...prev, year: { label: +year, value: +year } }))
    }
    refetch()
  }
  const handleChangeOrderBy = async (orderBy) => {
    setState((prev) => ({
      ...prev,
      orderBy:
        orderBy === "newest"
          ? {
              label: translations[`newest_${locale}`],
              value: "newest",
            }
          : {
              label: translations[`oldest_${locale}`],
              value: "oldest",
            },
    }))
    refetch()
  }
  useEffect(() => {
    if (data && state.year.value === 0) {
      const result = groupedByYear(data, Router.query?.orderBy)
      setState((prev) => ({ ...prev, list: result }))
    } else {
      setState((prev) => ({ ...prev, list: data }))
    }
  }, [data, state.year])
  useEffect(() => {
    // if (yearList?.postYearList?.length) {
    const allyear = { label: translations[`all_year_${locale}`], value: 0 }
    const list = yearList?.postYearList?.map((item) => ({
      label: item,
      value: item,
    }))
    list?.unshift(allyear)

    setState((prev) => ({
      ...prev,
      year: allyear,
      yearOptions: list,
    }))
    // }
  }, [locale])
  useEffect(() => {
    // if (Router.query?.year) {
    handleChangeYear(Router.query?.year)
    // }
    if (Router.query.orderBy) {
      handleChangeOrderBy(Router.query.orderBy)
    }
  }, [Router.query])
  return (
    <div className="investor-governance-with-filter__content">
      <div className="row row-filter mb-4">
        <div className="col-6 col-md-4">
          <Select
            floatingLabel
            variant="underline"
            label={translations[`year_${locale}`]}
            options={state.yearOptions}
            value={state.year}
            onChange={(_, val) => {
              if (val.value === 0) {
                const { slug, year, ...query } = Router.query
                Router.push(
                  {
                    pathname: Router.asPath?.split("?")[0],
                    query: { ...query },
                  },
                  null,
                  {
                    scroll: false,
                  }
                )
              } else {
                const { slug, ...query } = Router.query
                Router.push(
                  {
                    pathname: Router.asPath?.split("?")[0],
                    query: { ...query, year: val.value },
                  },
                  null,
                  { scroll: false }
                )
              }
            }}
          />
        </div>
        <div className="col-6 col-md-4">
          <Select
            floatingLabel
            variant="underline"
            label={translations[`sort_by_${locale}`]}
            options={[
              {
                label: translations[`newest_${locale}`],
                value: "newest",
              },
              {
                label: translations[`oldest_${locale}`],
                value: "oldest",
              },
            ]}
            value={state.orderBy}
            onChange={(_, val) => {
              const { slug, ...query } = Router.query
              Router.push(
                {
                  pathname: Router.asPath?.split("?")[0],
                  query: { ...query, orderBy: val.value },
                },
                null,
                { scroll: false }
              )
            }}
          />
        </div>
      </div>
      <div className="row row-list" ref={trigger}>
        {loading ? (
          <div className="loading-dots-wrapper">
            <h3 className="loading-dots">Loading</h3>
          </div>
        ) : (
          <div className="col-12">
            {state.year.value === 0 ? (
              state?.list?.length ? (
                state.list?.map((item) => (
                  <>
                    <h4 className="label">{item.year}</h4>
                    <div className="row mb-4">
                      {item.data?.map((itemList, i) => (
                        <div
                          className={
                            type === "governance" ? "col-12" : "col-lg-6"
                          }
                          key={`${keyPhrase}-${i}`}
                        >
                          {type === "governance" ? (
                            <GovernancePdfItem
                              title={itemList.title}
                              date={itemList.date}
                              linkPdf={itemList.pdfLink}
                            />
                          ) : (
                            <InvestorsPdfItem
                              title={itemList.title}
                              date={itemList.date}
                              linkPdf={itemList.pdfLink}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  </>
                ))
              ) : (
                <div className="empty-reports-wrapper">
                  <h3>{translations[`no_data_${locale}`]}</h3>
                </div>
              )
            ) : (
              <div className="row">
                {state?.list?.length ? (
                  state?.list?.map((item, i) => (
                    <div
                      className={type === "governance" ? "col-12" : "col-md-6"}
                      key={`${keyPhrase}-${i}`}
                    >
                      {type === "governance" ? (
                        <GovernancePdfItem
                          title={item.title}
                          date={item.date}
                          linkPdf={item.pdfLink}
                        />
                      ) : (
                        <InvestorsPdfItem
                          title={item.title}
                          date={item.date}
                          linkPdf={item.pdfLink}
                        />
                      )}
                    </div>
                  ))
                ) : (
                  <div className="empty-reports-wrapper">
                    <h3>{translations[`no_reports_${locale}`]}</h3>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default InvestorsGovernanceWithFilter
